import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { IpTableComponent } from 'src/app/invopay/components/ip-table/ip-table.component';
import { TableOption } from 'src/app/invopay/interfaces/Iip-table-options';
import { IpRoleService } from 'src/app/invopay/services/ip-role.service';
import { FnConsolidatedService } from '../../services/fn-consoldate.service';
import { TableEvent } from 'src/app/shared/components/table/Itable';
import { FnStatusModalComponent } from '../../components/fn-status-modal/fn-status-modal.component';

@Component({
  selector: 'app-fn-paid-orders',
  templateUrl: './fn-paid-orders.component.html',
  styleUrls: ['./fn-paid-orders.component.scss']
})
export class FnPaidOrdersComponent {
  tableOptions!: TableOption;
  type!: 'business' | 'employee' | 'provider';
  propertyOrder: string[] = [];

  @ViewChild(IpTableComponent) ipTable!: IpTableComponent;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private roleService: IpRoleService,
    private consolidatedService: FnConsolidatedService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.type = this.roleService.getType();
    this.propertyOrder = this.setProperty();

    this.tableOptions = {
      keyTranslate: this.setKeyTranslate(),
      selects: [],
      actions: this.setActions(),
      filters: this.setFilters(),
    };
  }

  setKeyTranslate(): string {
    return 'IP.TABLE.CONSOLIDATED';
  }

  setFilters(): Array<[string, string]> {
    switch (this.type) {
      case 'business':
      case 'provider':
        return [['IP.TABLE.DASHBOARD.FILTER.DATE-ISSUED', 'date']];
      default:
        return [];
    }
  }

  setProperty(): string[] {
    switch (this.type) {
      case 'business':
        return [
          'id_consolidated',
          'datetime_generate',
          'datetime_modified',
          'consolidated_name',
          'total_providers',
          'total_invoices',
          'total_amount',
          'observation',
        ];
      default:
        return [];
    }
  }

  setActions(): Array<string> {
    switch (this.type) {
      case 'business':
        return ['search', 'status', 'download'];
      default:
        return [];
    }
  }
  @Output() changeStatus = new EventEmitter<any>();
  async onAction(tableEvent: TableEvent) {
    const consolidated: any = tableEvent.dataField;
    const consolidatedId = consolidated.id_consolidated;

    switch (tableEvent.event) {
      case 'search':
        this.consolidatedService.currentConsolidate = {
          name: consolidated.consolidated_name ?? null, 
          createdBy: consolidated.createdBy ?? null, 
          modifiedBy: consolidated.modifiedBy ?? null, 
          lastModificationDate: consolidated.datetime_modified ?? null, 
        }
        this.router.navigate([
          '/invopay/admin/finance/consolidated-detail',
          { consolidatedId },
        ]);
        break;
      case 'status':
        const dialogRef = this.dialog.open(FnStatusModalComponent, {
          width: '400px',
          height: 'max-content',
          data: {
            consolidated: tableEvent.dataField,
          },
        });

        dialogRef.afterClosed().subscribe({
          next: () => {
            this.reloadConsolidatedList();
          },
        });
        break;
      case 'download':
        this.downloadCsv(consolidatedId)
        break;
    }
  }

  reloadConsolidatedList(): void {
    if (this.ipTable) {
      this.ipTable.executeService();
    }
  }

  downloadCsv(id:any){
    this.consolidatedService.getConsolidateDetails(id).subscribe({
      next: (response) => {
        const headersArray: string[] = ['proveedor/broker', 'Banco', 'sucursal', 'Nro_de_cuenta', 'nombre_del_titular', 'cuit','cantidad_de_facturas', 'ids_de_facturas', 'moneda', 'total'];
        let csv = headersArray.join(',')
        response.content.forEach((val: any) => {
          const row: string[] = [];
          row.push(val.businessName ?? '-')
          row.push(val.bank ?? '-')
          row.push(val.branchNumber ?? '-')
          row.push(val.accountNumber ?? '-')
          row.push(val.ownerName ?? '-')
          row.push(val.cuit ?? '-')
          row.push(val.totalInvoices ?? '-')
          row.push(val.invoicesIds ?? '-')
          row.push(val.currency ?? '-')
          row.push(val.amount ?? '-')
    
          csv = csv + "\n" + row.join(',')
        });
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        let link = document.createElement('a');
        let url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'consolidated-to-pay-file');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);    
      }
    });
  }
}
